import { osirisMoodysTheme } from '@risk-first/ui-theme';
import merge from 'lodash/merge';

const appTheme = {
  // overrides
};

export const theme = merge(osirisMoodysTheme, appTheme);
